import { getAuthToken, setEndeavorAccessToken } from './queries-utils';

let authTokenPromise: Promise<string> | null = null;

export const getSharedAuthToken = async (input: any) => {
  if (!authTokenPromise) {
    authTokenPromise = getAuthToken(input).then((token) => {
      setEndeavorAccessToken(token);
      authTokenPromise = null;
      return token;
    }).catch((error) => {
      authTokenPromise = null;
      throw error;
    });
  }
  return authTokenPromise;
};